import { ContextKindKey } from '@gonfalon/contexts/types';

import { isSegmentClause } from './isSegmentClause';
import type { Clause } from './types';

export function getClauseKind(clause: Clause) {
  if (clause.contextKind === ContextKindKey.APPLICATION) {
    return 'application';
  } else if (clause.contextKind === ContextKindKey.DEVICE) {
    return 'device';
  } else if (isSegmentClause(clause)) {
    return 'segment';
  } else {
    return 'custom';
  }
}
